module.exports = __webpack_public_path__ + "8527a00fb276e4083ba22f900baff053.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/fk.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/fk.svg
// module chunks = 0